export default "__VITE_ASSET__C0G718b7__"